module.exports = __webpack_public_path__ + "static/media/Mosaique_10.de38388e.png";